"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _makeStyles = _interopRequireDefault(require("@material-ui/core/styles/makeStyles"));

var _pickReactKnownProp = require("pick-react-known-prop");

var _HtmlHead = _interopRequireDefault(require("../../components/HtmlHead"));

var _PageBanner = _interopRequireDefault(require("../../components/PageBanner"));

var _HomePageCatalogueFavorite = _interopRequireDefault(require("./components/HomePageCatalogueFavorite"));

var _HomePageArticles = _interopRequireDefault(require("./components/HomePageArticles"));

var _HomePageProductOfMonth = _interopRequireDefault(require("./components/HomePageProductOfMonth"));

var _HomePageHotTips = _interopRequireDefault(require("./components/HomePageHotTips"));

var _HomepageJumbotron = _interopRequireDefault(require("./components/HomepageJumbotron"));

var _HomePageWhy = _interopRequireDefault(require("./components/HomePageWhy"));

// const HomePageRecommendCarousel = withChildrenIfStaticBuild(HomePageRecommendCarouselI);
var useStyles = (0, _makeStyles.default)(function () {
  return (
    /* theme*/
    {
      root: {}
    }
  );
}, {
  name: 'HomePage'
});

var _ref2 = /*#__PURE__*/_react.default.createElement(_HomepageJumbotron.default, null);

var _ref3 = /*#__PURE__*/_react.default.createElement(_HomePageHotTips.default, null);

var _ref4 = /*#__PURE__*/_react.default.createElement(_PageBanner.default, {
  position: "homepageMiddle",
  hideSkeleton: true
});

var _ref5 = /*#__PURE__*/_react.default.createElement(_HomePageProductOfMonth.default, null);

var _ref6 = /*#__PURE__*/_react.default.createElement(_HomePageWhy.default, null);

function HomePage(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      favoriteCategories = _ref.favoriteCategories,
      htmlHead = _ref.htmlHead,
      news = _ref.news,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["classes", "className", "favoriteCategories", "htmlHead", "news"]);
  var classes = useStyles({
    classes: pClasses
  });
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _pickReactKnownProp.pickHTMLProps)(rest), {
    className: (0, _clsx.default)(classes.root, className)
  }), htmlHead && /*#__PURE__*/_react.default.createElement(_HtmlHead.default, {
    htmlHead: htmlHead
  }), _ref2, /*#__PURE__*/_react.default.createElement(_HomePageCatalogueFavorite.default, {
    favoriteCategories: favoriteCategories,
    size: "normal"
  }), _ref3, _ref4, _ref5, _ref6, /*#__PURE__*/_react.default.createElement(_HomePageArticles.default, {
    news: news
  }));
}

process.env.NODE_ENV !== "production" ? HomePage.propTypes = {
  classes: _propTypes.default.shape({
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  favoriteCategories: _propTypes.default.arrayOf(_propTypes.default.shape({})).isRequired,
  htmlHead: _propTypes.default.shape({
    canonical: _propTypes.default.string,
    meta: _propTypes.default.arrayOf(_propTypes.default.shape({
      content: _propTypes.default.string,
      name: _propTypes.default.string
    })),
    title: _propTypes.default.string
  }),
  news: _propTypes.default.arrayOf(_propTypes.default.shape({
    comments: _propTypes.default.arrayOf(_propTypes.default.shape({})),
    href: _propTypes.default.string.isRequired,
    teaserImage: _propTypes.default.string,
    teaserText: _propTypes.default.string,
    title: _propTypes.default.string
  })).isRequired
} : void 0;
HomePage.defaultProps = {
  classes: undefined,
  className: undefined
};
var _default = HomePage;
exports.default = _default;